import { gql } from "graphql-request";

export const READ_OPERATIONAL_AUDITS = gql`
  query ReadOperationalAudits($companyId: ID) {
    readOperationalAudits(companyId: $companyId) {
      id
      tenantId
      companyId
      name
      industry
      status
      totalQuestionsAnswered
      totalProcessesIdentified
      documentedProcesses
      singlePersonDependencies
      unownedProcesses
      operationalResilienceScore
      createdAt
      updatedAt
      completedAt
    }
  }
`;

export const READ_OPERATIONAL_AUDIT = gql`
  query ReadOperationalAudit($id: ID!) {
    readOperationalAudit(id: $id) {
      id
      tenantId
      companyId
      name
      industry
      status
      areas
      questionIDs
      totalQuestionsAnswered
      totalProcessesIdentified
      documentedProcesses
      singlePersonDependencies
      unownedProcesses
      operationalResilienceScore
      createdAt
      updatedAt
      completedAt
    }
  }
`;

export const READ_AUDIT_AREA_SUMMARIES = gql`
  query ReadAuditAreaSummaries($industry: CompanyIndustry!) {
    readAuditAreaSummaries(industry: $industry) {
      area
      questionCount
    }
  }
`;